(function () {
  "use strict";
  if (window.__humanodoroPrivacyReady) return;
  window.__humanodoroPrivacyReady = true;

  // Shopify is the consent authority. Never replay an old local accept/reject.
  try {
    window.localStorage.removeItem("humanodoro_cookie_consent_v1");
    window.localStorage.removeItem("humanodoro-cookie-choice");
  } catch (error) {}

  function start() {
    var banner = document.querySelector("[data-hd-cookie]");
    var buttons = banner ? banner.querySelectorAll("[data-hd-cookie-action]") : [];
    var purposes = banner ? banner.querySelectorAll("[data-hd-cookie-purpose]") : [];
    var errorNode = banner ? banner.querySelector("[data-hd-cookie-error]") : null;
    var details = banner ? banner.querySelector("[data-hd-cookie-choices]") : null;
    var manual = false;
    var saving = false;
    var opener = null;
    var loadPending = false;
    var attempts = 0;
    var loadCallbacks = [];
    var loadTimeout = null;
    var lastState = null;
    var reloading = false;
    var pixelPausedForChoice = false;

    // Meta documents consent revoke/grant as its client pause API. Pause before
    // privacy-control clicks reach its automatic button listener. Never grant
    // this page again: a saved/closed choice reloads, discarding queued privacy
    // interactions. Shopify still owns every permission and commerce event.
    function pausePixelForChoice() {
      if (typeof window.fbq !== "function") return;
      try {
        window.fbq("consent", "revoke");
        pixelPausedForChoice = true;
      } catch (error) {}
    }
    function privacyControl(event) {
      var path = typeof event.composedPath === "function" ? event.composedPath() : [event.target];
      return path.some(function (node) {
        return node && typeof node.closest === "function" && node.closest(
          '[data-hd-cookie], [data-hd-cookie-manage], a[href="#shopifyReshowConsentBanner"], #shopify-pc__banner, #shopify-pc__prefs'
        );
      });
    }
    function nativeClose(event) {
      var target = event.target;
      return target && typeof target.closest === "function" && (
        target.closest("#shopify-pc__prefs__header-close") || target.id === "shopify-pc__prefs__overlay"
      );
    }
    window.addEventListener("click", function (event) {
      if (!privacyControl(event)) return;
      pausePixelForChoice();
      if (pixelPausedForChoice && nativeClose(event)) window.setTimeout(reloadAfterRevocation, 0);
    }, true);
    window.addEventListener("keydown", function (event) {
      if (!privacyControl(event)) return;
      if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") pausePixelForChoice();
      if (event.key === "Escape" && pixelPausedForChoice && !banner) window.setTimeout(reloadAfterRevocation, 0);
    }, true);

    function privacy() {
      return window.Shopify && window.Shopify.customerPrivacy;
    }
    function current() {
      var api = privacy();
      var state = api && typeof api.currentVisitorConsent === "function"
        ? api.currentVisitorConsent() : {};
      return Object.assign({}, state);
    }
    function hasDecision(state) {
      return ["analytics", "marketing", "preferences"].every(function (key) {
        return state[key] === "yes" || state[key] === "no";
      });
    }
    function fillChoices(state) {
      purposes.forEach(function (input) {
        input.checked = state[input.getAttribute("data-hd-cookie-purpose")] === "yes";
      });
    }
    function busy(value) {
      saving = value;
      buttons.forEach(function (button) {
        button.disabled = value;
        button.setAttribute("aria-busy", String(value));
      });
    }
    function visible(value) {
      if (!banner) return;
      banner.classList.toggle("is-hidden", !value);
      banner.hidden = !value;
      banner.setAttribute("aria-hidden", String(!value));
    }
    function fail() {
      busy(false);
      visible(true);
      if (errorNode) errorNode.hidden = false;
    }
    function downgrade(previous, state) {
      return previous && ["analytics", "marketing", "preferences"].some(function (key) {
        return previous[key] === "yes" && state[key] === "no";
      });
    }
    function reloadAfterRevocation() {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    }
    function sync() {
      var api = privacy();
      if (!api || saving) return;
      var state = current();
      var revoked = downgrade(lastState, state);
      lastState = state;
      if (revoked) reloadAfterRevocation();
      if (!banner) return;
      fillChoices(state);
      var inRegion = typeof api.shouldShowBanner !== "function" || api.shouldShowBanner();
      visible(manual || (inRegion && !hasDecision(state)));
      document.body.classList.add("hd-custom-consent");
    }
    function load(callback) {
      loadCallbacks.push(callback);
      if (loadPending) return;
      loadPending = true;
      attempts = 0;
      loadTimeout = window.setTimeout(function () { finishLoad(null); }, 8000);
      tryLoad();
    }
    function finishLoad(api) {
      if (!loadPending) return;
      window.clearTimeout(loadTimeout);
      loadPending = false;
      var callbacks = loadCallbacks.splice(0);
      if (!api) {
        fail();
        return;
      }
      callbacks.forEach(function (callback) { callback(api); });
    }
    function tryLoad() {
      var api = privacy();
      if (api && typeof api.setTrackingConsent === "function") {
        finishLoad(api);
        return;
      }
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        try {
          window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
          var loaded = privacy();
          if (error || !loaded || typeof loaded.setTrackingConsent !== "function") {
            finishLoad(null);
            return;
          }
          finishLoad(loaded);
          });
        } catch (error) { finishLoad(null); }
      } else if (attempts++ < 40) {
        window.setTimeout(tryLoad, 100);
      } else {
        finishLoad(null);
      }
    }
    function save(action) {
      if (saving) return;
      var choice = { analytics: false, marketing: false, preferences: false };
      if (action === "accept") {
        Object.keys(choice).forEach(function (key) { choice[key] = true; });
      } else if (action === "save") {
        purposes.forEach(function (input) {
          choice[input.getAttribute("data-hd-cookie-purpose")] = input.checked;
        });
      } else if (action !== "reject") {
        return;
      }
      busy(true);
      if (errorNode) errorNode.hidden = true;
      load(function (api) {
        var previous = current();
        var completed = false;
        var timeout = window.setTimeout(function () {
          if (completed) return;
          completed = true;
          fail();
        }, 8000);
        try {
          // Do not set sale_of_data: preserve Shopify's independent opt-out/GPC.
          api.setTrackingConsent(choice, function (result) {
            if (completed) return;
            completed = true;
            window.clearTimeout(timeout);
            var state = current();
            var confirmed = Object.keys(choice).every(function (key) {
              return state[key] === (choice[key] ? "yes" : "no");
            });
            if ((result && result.error) || !confirmed) {
              fail();
              return;
            }
            manual = false;
            busy(false);
            lastState = state;
            fillChoices(state);
            visible(false);
            if (opener && opener.isConnected) opener.focus();
            // Discard already-loaded third-party code on a downgrade. The new
            // page uses the saved Shopify permissions; cart/checkout stay intact.
            if (downgrade(previous, state) || pixelPausedForChoice) reloadAfterRevocation();
          });
        } catch (error) {
          completed = true;
          window.clearTimeout(timeout);
          fail();
        }
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        save(button.getAttribute("data-hd-cookie-action"));
      });
    });
    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-hd-cookie-manage]");
      if (!trigger) return;
      event.preventDefault();
      opener = trigger;
      if (!banner) {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
          window.privacyBanner.showPreferences();
        }
        return;
      }
      manual = true;
      load(function () {
        sync();
        if (details) details.open = true;
        var heading = banner.querySelector("[data-hd-cookie-title]");
        if (heading) heading.focus();
      });
    });
    document.addEventListener("visitorConsentCollected", function () {
      sync();
      // Only a confirmed native choice closes a paused native preference flow.
      // Opening/synchronizing the custom editor must not reload before editing.
      if (!saving && pixelPausedForChoice) reloadAfterRevocation();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || !manual || saving || !hasDecision(current())) return;
      manual = false;
      visible(false);
      if (opener && opener.isConnected) opener.focus();
      if (pixelPausedForChoice) reloadAfterRevocation();
    });
    load(sync);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
